<div class="loader-wr" *ngIf="isloading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
